import Radio from './Radio';
import RadioButton from './RadioButton';
import RadioGroup from './RadioGroup';

Radio.Button = RadioButton;
Radio.Group = RadioGroup;

export default Radio;


//////////////////
// WEBPACK FOOTER
// ./~/element-react/dist/npm/es6/src/radio/index.js
// module id = 421
// module chunks = 0